import React from "react";
import ActivityTimelineItem from "./ActivityTimelineItem";

const ActivityTimeline = ({ groups = [], className = "" }) => {
  return (
    <div className={`flex flex-col w-full ${className}`}>
      {groups.map((group) => (
        <div key={group.date} className="w-full">
          {/* Date section header */}
          <div className="flex items-center w-full my-4">
            <span className="font-poppins font-medium text-xs text-[#000000] uppercase tracking-wider flex-shrink-0">
              {group.date}
            </span>
            <div className="flex-1 h-[1px] bg-light-grey ml-3" />
          </div>

          {/* Activities list for this date */}
          <div className="flex flex-col w-full gap-4">
            {group.activities?.map((activity, index) => (
              <ActivityTimelineItem
                key={activity.id || index}
                activity={activity}
                isFirst={index === 0}
                // isLast={index === group.activities.length - 1}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
